import { Link } from "react-router-dom";
import Logo from "./Logo";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-sp-dark text-white/70 overflow-hidden sp-grain"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo variant="dark" />
            <p className="mt-6 max-w-sm font-sans text-sm leading-relaxed text-white/55">
              A corporate advisory entity, and an affiliate of the Sunly Properties
              group, with interests across energy, aviation and carbon markets.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="sp-eyebrow text-white/40">Navigate</p>
            <ul className="mt-5 space-y-3 font-sans text-sm">
              <li><Link data-testid="footer-who" to="/who-we-are" className="hover:text-white transition-colors duration-300">Who We Are</Link></li>
              <li><Link data-testid="footer-directors" to="/directors" className="hover:text-white transition-colors duration-300">Directors</Link></li>
              <li><Link data-testid="footer-projects" to="/projects" className="hover:text-white transition-colors duration-300">Projects</Link></li>
              <li><Link data-testid="footer-connect" to="/connect" className="hover:text-white transition-colors duration-300">Connect</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="sp-eyebrow text-white/40">Contact</p>
            <ul className="mt-5 space-y-3 font-sans text-sm">
              <li>
                <a data-testid="footer-email" href="mailto:admin@sunlyprime.asia" className="hover:text-white transition-colors duration-300">
                  admin@sunlyprime.asia
                </a>
              </li>
              <li className="text-white/45">sunlyprime.asia</li>
              <li className="pt-2">
                <Link data-testid="footer-admin-link" to="/admin" className="text-white/40 hover:text-white/80 text-xs tracking-wide transition-colors duration-300">
                  Administrator Console
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 font-mono text-xs text-white/35">
          <span>&copy; {new Date().getFullYear()} Sunly Prime. All rights reserved.</span>
          <span>An affiliate of the Sunly Properties group.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
